export const PROMO_MODE_NAMES = ['none', 'optional', 'required'];
//# sourceMappingURL=promo-mode-names.js.map